import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import '../../Css/TextLayer.css';

// PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Check = () => {
  const location = useLocation();
  const pdfUrl = location.state?.pdf_link;

  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);
  const [pageWidth, setPageWidth] = useState(getResponsiveWidth());

  function getResponsiveWidth() {
    if (window.innerWidth < 600) return window.innerWidth - 20;
    if (window.innerWidth < 900) return 600;
    return 800;
  }

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(getResponsiveWidth());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleZoomIn = () => {
    setScale((prev) => Math.min(prev + 0.2, 3));
  };

  const handleZoomOut = () => {
    setScale((prev) => Math.max(prev - 0.2, 0.5)); 
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.buttonContainer}>
        <button onClick={handleZoomOut} style={styles.button}>➖ Zoom Out</button>
        <button onClick={handleZoomIn} style={styles.button}>➕ Zoom In</button>
      </div>

      <div style={styles.scrollContainer}>
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={
            <div className='course_container'>
                <div className="loader">
                    Loading pdf...
                    <div className="spinner" />
                </div>
            </div>
          }
          error={<div>Failed to load PDF.</div>}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              scale={scale}
              width={pageWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default Check;

const styles = {
  wrapper: {
    padding: '1rem',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  scrollContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonContainer: {
    position: 'fixed',
    bottom: '1rem',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'fit-content',
    maxWidth: '95vw',
    backgroundColor: '#fff',
    padding: '0.5rem 1rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    borderRadius: '12px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)',
    zIndex: 1000,
    boxSizing: 'border-box',
    flexWrap: 'nowrap',
  },

  button: {
    padding: '0.6rem 1.2rem',
    fontSize: '0.95rem',
    minWidth: '110px',
    backgroundColor: '#09636e',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flex: '0 1 auto', 
  },


};